'use client';

import { type CSSProperties, useState } from 'react';
import { createPortal } from 'react-dom';
import { MacaronFullScreenModalOpenContext } from './scope';
import type { MacaronRenderContext, RecordAny } from '@macaron-a2ui/core/v0_8';

const MODAL_SHELL_STYLE: CSSProperties = { position: 'fixed', inset: 0, zIndex: 320, display: 'flex', backgroundColor: '#FCFAF7' };
const MODAL_BODY_STYLE: CSSProperties = { display: 'flex', minHeight: 0, width: '100%', flexDirection: 'column' };
const MODAL_HEADER_STYLE: CSSProperties = { display: 'flex', height: 56, flexShrink: 0, alignItems: 'center', justifyContent: 'flex-start', padding: '0 1rem' };
const MODAL_CLOSE_STYLE: CSSProperties = {
  display: 'flex',
  height: 36,
  width: 36,
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: 9999,
  backgroundColor: '#fff',
  color: '#595856',
  boxShadow: '0 1px 2px rgba(22,22,21,0.08)',
  border: '1px solid #E7DDD2',
  fontSize: 20,
  lineHeight: 1,
};
const MODAL_SCROLL_STYLE: CSSProperties = { minHeight: 0, flex: 1, overflowY: 'auto', padding: '0 1rem 1.5rem' };
const MODAL_CONTENT_STYLE: CSSProperties = { width: '100%', maxWidth: 720, margin: '0 auto' };

export function MacaronFullScreenModal({ config, ctx }: { config: RecordAny; ctx: MacaronRenderContext }) {
  const entryPointChild = typeof config.entryPointChild === 'string' ? config.entryPointChild : '';
  const contentChild = typeof config.contentChild === 'string' ? config.contentChild : '';
  const [open, setOpen] = useState(false);
  const modal =
    open && contentChild ? (
      <div role="dialog" aria-modal="true" style={MODAL_SHELL_STYLE}>
        <div style={MODAL_BODY_STYLE}>
          <div style={MODAL_HEADER_STYLE}>
            <button type="button" style={MODAL_CLOSE_STYLE} aria-label="Close full screen modal" onClick={() => setOpen(false)}>
              &times;
            </button>
          </div>
          <div style={MODAL_SCROLL_STYLE}>
            <div style={MODAL_CONTENT_STYLE}>{ctx.renderChild(contentChild)}</div>
          </div>
        </div>
      </div>
    ) : null;

  return (
    <>
      {entryPointChild ? <MacaronFullScreenModalOpenContext.Provider value={() => setOpen(true)}>{ctx.renderChild(entryPointChild)}</MacaronFullScreenModalOpenContext.Provider> : null}
      {modal && typeof document !== 'undefined' ? createPortal(modal, document.body) : null}
    </>
  );
}
